<script setup>
defineProps({
  modelValue: { type: String, default: '' },
  options: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <fieldset class="grid gap-[15px]">
    <label
      v-for="option in options"
      :key="option.id"
      class="flex min-h-[72px] items-center gap-3 rounded-[10px] border border-lais-primary-200 bg-white px-5 py-4 text-base font-medium text-lais-text shadow-[0_0_6px_0_rgba(0,0,0,0.02),0_2px_4px_0_rgba(0,0,0,0.08)] transition-colors hover:border-lais-primary-600"
    >
      <input
        type="radio"
        :checked="String(option.id) === modelValue"
        :value="String(option.id)"
        @change="emit('update:modelValue', String(option.id))"
      />
      <span>{{ option.label }}</span>
    </label>
  </fieldset>
</template>
